export const THEME_CATEGORY = {
  SBE: 'SBE',   // Hosted themes
  SBEM: 'SBEM'  // In-context themes
};



// WEBPACK FOOTER //
// ./src/constants/ThemeCategories.js